import type { PracticalProject } from "../../data";

export const taskManagement: PracticalProject = {
  id: "task-management",
  num: 2,
  title:
    "実践プロジェクト② タスク管理アプリ — Node.js + Express + Prisma + PostgreSQL + React で認証つき業務 SaaS を構築する",
  description:
    "ハミングバード合同会社向けの社内タスク見える化アプリを、JWT 認証 + 楽観ロック込みでフルスタック構築",
  duration: "1〜2か月",
  techStack: [
    "TypeScript",
    "Node.js",
    "Express",
    "Prisma",
    "PostgreSQL",
    "React",
    "Vite",
    "Tailwind",
  ],
  figmaUrl:
    "https://www.figma.com/design/5LLAPdI03tsb3z0ufTofP6/?node-id=13-1893",
  demoUrl: "https://prod-luagate-pj-taskapp-frontend-v3bbmayaea-an.a.run.app",
  starterUrl:
    "https://prod-luagate-pj-taskapp-starter-frontend-645657172748.asia-northeast1.run.app",
  repoUrl: "https://github.com/Luagate-com/luagate_pj_task_app",
  starterRepoUrl:
    "https://github.com/Luagate-com/luagate_pj_task_app/tree/starter",
  difficulty: "intermediate",
  phase: "Phase 4",
  learningOutcomes: [
    "React + Node.js + PostgreSQL で CRUD 一式を実装できるようになる",
    "ユーザー認証・セッション管理を JWT + localStorage + Authorization Bearer ヘッダで組めるようになる",
    "REST API 設計とフロント連携の基本を身につける",
    "タスク管理アプリをポートフォリオに持てる",
  ],
  chapters: [
    { num: 1, title: "はじめに" },
    { num: 2, title: "ヒアリング" },
    { num: 3, title: "企画書" },
    { num: 4, title: "要件定義" },
    {
      num: 5,
      title: "基本設計",
      figmaFrames: [
        { title: "タスク管理アプリ (メイン)", nodeId: "13-1893" },
      ],
    },
    { num: 6, title: "詳細設計" },
    { num: 7, title: "実装の進め方" },
    {
      num: 8,
      title: "7-1: 環境構築 (Codespaces + Neon + 雛形起動)",
    },
    {
      num: 9,
      title: "7-2: Prisma スキーマ定義と migration / seed 投入",
    },
    {
      num: 10,
      title: "7-3: 認証 API (register / login / JWT 発行)",
    },
    {
      num: 11,
      title: "7-4: タスク CRUD API (一覧 / 作成 / 更新 / 削除 + 楽観ロック)",
    },
    {
      num: 12,
      title: "7-5: Frontend ログイン / 登録画面と JWT 保存",
      figmaFrames: [
        { title: "タスク管理アプリ (メイン)", nodeId: "13-1893" },
      ],
    },
    {
      num: 13,
      title: "7-6: タスク一覧画面 (Tailwind リスト UI + ステータスフィルタ)",
      figmaFrames: [
        { title: "タスク管理アプリ (メイン)", nodeId: "13-1893" },
      ],
    },
    {
      num: 14,
      title: "7-7: タスクの作成・編集・削除モーダル",
      figmaFrames: [
        { title: "タスク管理アプリ (メイン)", nodeId: "13-1893" },
      ],
    },
    { num: 15, title: "7-8: 仕上げ (CSS・エラー・セキュリティ)" },
    { num: 16, title: "実装 FAQ (詰まったとき用)" },
    { num: 17, title: "テスト・提出" },
    { num: 18, title: "用語ミニ辞書" },
  ],
};
